<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import BarcodesForm from "./BarcodesForm.vue";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import Buttons from "../../../../../components/ui/form/Buttons.vue";

const props = defineProps<{
  data?: any | [];
  unit_of_measures?: any | [];
  permissions?: Permission[];
  item?: any | null;
}>();

const endPoint = "/clients/inventory/item-management/items/barcode-";
const title = "Barcodes";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [
  { name: "code", caption: "Code", sortable: true, fieldType: "text" },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const handleSave = (data: any) => {
  rows.value = data;
};

const handleCreate = () => {
  selectedData.value = null;
  formMode.value = "create";
  showForm.value = true;
};

onMounted(() => {
  rows.value = props.data;
});

watch(
  () => props.data,
  () => {
    rows.value = props.data;
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="false"
    :ignore-max-height="true"
  >
    <template #header-actions>
      <Buttons icon="Plus" caption="New Barcode" @click="handleCreate" />
    </template>
    <template #form-view> </template>
  </ListTemplate>
  <BarcodesForm
    :permissions="permissions"
    :item="item"
    v-if="showForm"
    :data="selectedData"
    :end-point="endPoint"
    :title="title"
    :mode="formMode"
    @save="handleSave"
    @close="showForm = !showForm"
  />
</template>
